import { Button, Icon } from "armstrong-react";
import React from "react";
import { Dialog, FlowBox } from "../../../core/atoms/atoms";
import { CustomErrors } from "../../../shared/errors";

import "./confirmationDialog.scss";

interface IConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => Promise<any> | void;
  title?: string;
  message?: string;
  confirmLabel?: string;
  confirmIcon?: string;
  cancelLabel?: string;
  cancelIcon?: string;
  className?: string;
}

interface IConfirmationDialogState {
  pending?: boolean;
  errorMessage?: string;
}

export class ConfirmationDialog extends React.Component<IConfirmationDialogProps, IConfirmationDialogState> {
  public onConfirm?: () => Promise<any> | void;

  public constructor(props) {
    super(props);
    this.state = {};
  }

  private async onConfirmAsync() {
    const confirmCallback = this.props.onConfirm || this.onConfirm;
    if (!confirmCallback) {
      this.props.onClose();
      return;
    }

    this.setState({ pending: true }, async () => {
      try {
        await confirmCallback();
        this.setState({ pending: false, errorMessage: null });
        this.props.onClose();
      }
      catch (e) {
        const msg: string = this.isApiValidationError(e) ? e.validations.map(e => e.message).join(", ") : e.message;
        this.setState({ pending: false, errorMessage: msg });
      }
    });
  }

  private isApiValidationError(e) {
    return (e instanceof CustomErrors.ApiError) && (typeof e.validations !== "undefined") && (e.validations.length > 0);
  }

  public render() {
    return (
      <Dialog
        title={this.props.title || "Are you sure?"}
        onClose={this.props.onClose}
        isOpen={this.props.isOpen}
        className={`${this.props.className} confirmation-layer`}
        ariaLabel="Confirmation"
      >
        {this.state.errorMessage &&
          <div className="validation-bar">
            Something went wrong - {this.state.errorMessage}
          </div>
        }

        <div>
          {this.props.children == null &&
            <p style={{ whiteSpace: "pre-wrap" }}>
              {`${this.props.message || "Are you sure?"}`}
            </p>
          }
          {this.props.children}

          <FlowBox>
            <Button
              className="cancel"
              leftIcon={this.props.cancelIcon || Icon.Icomoon.cross}
              onClick={this.props.onClose}
            >
              {this.props.cancelLabel || "No"}
            </Button>

            <Button
              className="confirm"
              leftIcon={this.props.confirmIcon || Icon.Icomoon.checkmark}
              onClick={() => this.onConfirmAsync()}
              pending={this.state.pending}
            >
              {this.props.confirmLabel || "Yes"}
            </Button>
          </FlowBox>
        </div>
      </Dialog>
    );
  }
}
